/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente__Dolar_95_36 as Componente__Dolar_95_36,
  rec_Componente_vDolar_118_36 as Componente_vDolar_118_36,
  rec_Di as Di,
  rec_Ei as Ei,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_FormularioRuta as FormularioRuta,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MQ as MQ,
  rec_React as React,
  rec_Ti as Ti,
  rec_api as api,
  rec_wi as wi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function RutasTransporte() {
  let e = Go(),
    { confirmar: t } = Fo(),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(!0),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(null),
    p = (0, React.useMemo)(() => {
      let e = i.trim().toLowerCase();
      return e
        ? n.filter((t) =>
            [t.origen, t.destino, t.tipo]
              .filter(Boolean)
              .some((t) => t.toLowerCase().includes(e)),
          )
        : n;
    }, [n, i]),
    m = (0, React.useCallback)(async () => {
      s(!0);
      try {
        (r(await api(`/transporte/tarifario`)), l(``));
      } catch (e) {
        l(e.message);
      } finally {
        s(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    m();
  }, [m]);
  async function h(n) {
    let r = !n.activo,
      i = `${n.origen} → ${n.destino}`;
    if (
      r ||
      (await t({
        titulo: `Dejar de usar`,
        mensaje: `${i} deja de proponerse al cerrar una orden. Las órdenes que ya se cerraron con este precio no cambian.`,
        confirmarTexto: `Dejar de usar`,
      }))
    )
      try {
        (await api(`/transporte/tarifario`, {
          method: `POST`,
          body: JSON.stringify({
            id: n.id,
            origen: n.origen,
            destino: n.destino,
            tipo: n.tipo,
            precio: n.precio,
            minutosViaje: n.minutosViaje ?? null,
            activo: r,
          }),
        }),
          e.ok(r ? `${i} vuelve a proponerse` : `${i} ya no se propone`),
          m());
      } catch (t) {
        e.error(t.message);
      }
  }
  return (
    <div
      className={`flex flex-col gap-3`}
      children={[
        <EstadoError mensaje={c} onReintentar={m} />,
        <section
          className={`${Bo} flex items-start justify-between gap-3`}
          children={[
            <div
              children={[
                <p
                  className={`font-medium text-(--text-h)`}
                  children={`Precios acordados`}
                />,
                <p
                  className={`text-sm text-(--text)`}
                  children={`Al cerrar una orden, el precio de la ruta se propone solo. Es de referencia: se puede cobrar otra cosa y queda anotado que se cambió.`}
                />,
              ]}
            />,
            <button
              type={`button`}
              onClick={() => f({})}
              className={zo}
              children={[
                <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                ` Nueva ruta`,
              ]}
            />,
          ]}
        />,
        <input
          type={`search`}
          value={i}
          onChange={(e) => a(e.target.value)}
          placeholder={`Buscar por origen, destino o tipo de unidad`}
          className={Lo}
        />,
        o ? (
          <Componente__Dolar_95_36 />
        ) : c ? null : n.length === 0 ? (
          <Componente_vDolar_118_36
            texto={`Todavía no hay precios acordados. Agregá las rutas que se repiten.`}
          />
        ) : p.length === 0 ? (
          <p
            className={`text-sm text-(--text)`}
            children={`Ninguna coincide con lo que buscaste.`}
          />
        ) : (
          <div
            className={`${Bo} max-h-[30rem] overflow-y-auto p-2`}
            children={
              <ul
                className={`grid grid-cols-1 gap-x-4 lg:grid-cols-2`}
                children={p.map((e) => (
                  <li
                    key={e.id}
                    className={`group flex items-center gap-3 rounded-lg px-2 py-1.5 transition hover:bg-(--panel) ${e.activo ? `` : `opacity-60`}`}
                    children={[
                      <div
                        className={`min-w-0 flex-1`}
                        children={[
                          <p
                            className={`truncate text-sm text-(--text-h)`}
                            children={[e.origen, ` → `, e.destino]}
                          />,
                          <p
                            className={`text-xs text-(--text)`}
                            children={[
                              e.tipo,
                              e.minutosViaje ? ` · ${e.minutosViaje} min` : ``,
                            ]}
                          />,
                        ]}
                      />,
                      <span
                        className={`whitespace-nowrap text-sm font-medium text-(--text-h)`}
                        children={MQ(e.precio)}
                      />,
                      !e.activo && (
                        <span
                          className={`text-[10px] uppercase text-(--text)`}
                          children={`sin uso`}
                        />
                      ),
                      <div
                        className={`flex shrink-0 gap-0.5 opacity-0 transition group-hover:opacity-100 focus-within:opacity-100 max-sm:opacity-100`}
                        children={[
                          <button
                            type={`button`}
                            onClick={() =>
                              f({
                                editar: e,
                              })
                            }
                            aria-label={`Editar ${e.origen} a ${e.destino}`}
                            className={`rounded-lg p-2 text-(--text) hover:bg-(--accent-bg) hover:text-(--accent)`}
                            children={(0, JSXRuntime.jsx)(wi, {
                              className: `h-3.5 w-3.5`,
                            })}
                          />,
                          <button
                            type={`button`}
                            onClick={() => h(e)}
                            aria-label={`${e.activo ? `Dejar de usar` : `Volver a usar`} ${e.origen} a ${e.destino}`}
                            className={`rounded-lg p-2 text-(--text) ${e.activo ? `hover:bg-(--panel) hover:text-(--error)` : `hover:bg-(--accent-bg) hover:text-(--accent)`}`}
                            children={
                              e.activo ? (
                                <Ei className={`h-3.5 w-3.5`} />
                              ) : (
                                <Di className={`h-3.5 w-3.5`} />
                              )
                            }
                          />,
                        ]}
                      />,
                    ]}
                  />
                ))}
              />
            }
          />
        ),
        u && (
          <FormularioRuta
            editar={u.editar}
            onClose={() => f(null)}
            onGuardado={() => {
              (f(null), e.ok(`Precio guardado`), m());
            }}
          />
        ),
      ]}
    />
  );
}
